import { commoditiesOptions, additionsOptions } from '../containers/PublishForm/PublishPropertyFormConstants';

const paramsContain = (params, array) => (params.some(item => array.indexOf(item) >= 0));

const checkAdvancedFiltersQuantity = (params, withPrice) => {
  const buildingCommoditiesValues = commoditiesOptions(() => { }).map(item => item.id);
  const propertyCommoditiesValues = additionsOptions(() => { }).map(item => item.id);
  const buildingCommodities = params.commodities ? paramsContain(params.commodities, buildingCommoditiesValues) : 0;
  const apartmentCommodities = params.commodities ? paramsContain(params.commodities, propertyCommoditiesValues) : 0;

  const floor = params.floor && (params.floor.min || params.floor.max);
  const notLastFloor = params.notLastFloor;
  const floorCount = (floor || notLastFloor) ? 1 : 0;

  const bathrooms = (params.bathrooms && params.bathrooms.length && params.bathrooms[0] !== 'all') ? 1 : 0;
  const toilets = (params.toilets && params.toilets.length && params.toilets[0] !== 'all') ? 1 : 0;
  const year = params.constructionYear && (params.constructionYear.min || params.constructionYear.max) ? 1 : 0;
  const area = params.area && (params.area.min || params.area.max) ? 1 : 0;

  const keys = ['balcony', 'elevator', 'parkingSpot', 'photos'];


  const price = withPrice && (params.price.minPrice || params.price.minPrice) ? 1 : 0;
  const valuesCount = keys.filter(key =>
    ((typeof params[key] === 'boolean') && params[key])).length;

  const num = valuesCount +
    buildingCommodities +
    apartmentCommodities +
    floorCount +
    bathrooms +
    toilets +
    year +
    area +
    price;
  return num;
};


export default checkAdvancedFiltersQuantity;
